import * as actionTypes from "auth/authActionTypes";
import { LOCAL_STORAGE_CURRENT_ORG_KEY } from "./authEpic";
import { isNil } from "ramda";

const setCurrentOrgInLocalStorage = ({ organization, userId }) => {
  const org = isNil(organization) ? null : organization.id;
  console.log("Storing current org in local storage, org: %O", org);
  localStorage.setItem(LOCAL_STORAGE_CURRENT_ORG_KEY + userId, org);
};

const persistAuthData = store => next => action => {
  let result;

  switch (action.type) {
    case actionTypes.SET_CURRENT_ORGANIZATION:
      setCurrentOrgInLocalStorage(action);
      result = next(action);
      return result;
    default:
      result = next(action);
      return result;
  }
};

export default persistAuthData;
